import ActionTypes from './../Action/ActionTypes';
import moment from 'moment';
import { DdLogs } from '../src/logging/datadog';
export default function ShiftLogsReducer(preState = { shiftLogs: [], isLoading: false }, action) {
  switch (action.type) {
    case ActionTypes.LOADINGINPROGRESS: {
      DdLogs.info('loading reducer');
      return {
        ...preState,
        isLoading: false,
      };
    }
    case ActionTypes.GET_SHIFTLOGS: {
      let newDataOrder = action.payload
        .map((val) => {
          const mapped = {
            ...val,
            createTime: new Date(val.createTime).getTime(),
          };

          if (preState.shiftLogs.length > 0) {
            let pre = preState.shiftLogs.find((u) => u.shiftSummaryID == val.shiftSummaryID);
            if (pre && pre.status == val.status) {
              if (moment(val.submitTime).isSameOrBefore(pre.submitTime)) {
                mapped.fileContent = pre.fileContent;
              }
            }
          }
          return mapped;
        })
        .sort((a, b) => b.createTime - a.createTime);
      return {
        shiftLogs: [...newDataOrder],
        isLoading: false,
      };
    }
    case ActionTypes.UPDATE_SHIFTLOG: {
      DdLogs.info('update_shitlogs reducer');
      let currentShiftLog = action.payload;
      let previousShiftLogs = [...preState.shiftLogs];
      let preShiftLog = previousShiftLogs.find(
        (u) => u.shiftSummaryID == currentShiftLog.shiftSummaryID,
      );
      let combinedShiftLog = {};

      //combine current and previous:
      switch (currentShiftLog.fileStatus) {
        //if logs in inprogress state. filecontent will be empty
        case 'NoFile':
          {
            combinedShiftLog = {
              ...preShiftLog,
              ...currentShiftLog,
            };
          }
          break;
        // if fileDownload is false
        case 'NoDownload':
          {
            combinedShiftLog = {
              ...preShiftLog,
              ...currentShiftLog,
            };
          }
          break;
        case 'NoUpdate':
          let fileContent = preShiftLog.fileContent;
          combinedShiftLog = {
            ...preShiftLog,
            ...currentShiftLog,
            fileContent,
          };
          break;
        case 'Download':
          DdLogs.info('case Download: ');
          combinedShiftLog = {
            ...preShiftLog,
            ...currentShiftLog,
            lastUpdate: moment.utc(Date.now()).format(),
          };
          break;
        default:
          combinedShiftLog = {
            ...currentShiftLog,
          };
      }

      let ind = previousShiftLogs.findIndex(
        (u) => u.shiftSummaryID == currentShiftLog.shiftSummaryID,
      );
      ind >= 0 && previousShiftLogs.splice(ind, 1, combinedShiftLog);
      return {
        ...preState,
        shiftLogs: previousShiftLogs,
      };
    }

    default:
      return preState;
  }
}